import type { ReactElement } from "react";
import { useHistory, useRouteMatch } from "react-router-dom";
import {
  Card,
  Text,
  Logo,
  Flex,
  Table,
  TableBody,
  TableCell,
  TableHeader,
  TableRow,
} from "@jsq/ds/core";
import { Column, ColumnContainer } from "@jsq/ds/layouts";
import { withClientContext } from "~/apollo/client";
import { ApplicationContext } from "~/graphql/mainEnums";
import { useGetArenasForFayQuery } from "~/graphql/supergraphHooks";
import { toDbId } from "~/utils/graphql-helpers";

export const Arenas = (): ReactElement => {
  const { path } = useRouteMatch();
  const history = useHistory();

  const { data, loading, error } = useGetArenasForFayQuery({
    context: withClientContext("federation"),
    fetchPolicy: "cache-and-network",
    variables: {
      includeAdminArena: false,
      applicationContext: ApplicationContext.AdminFundAccounting,
      filterByActiveArenaAccesses: true,
    },
  });

  if (loading) {
    return <Text>Loading</Text>;
  }

  if (error || !data) {
    return <Text>Error</Text>;
  }

  const arenas = data.arenas?.edges.map((e) => e.node);

  const handleRowClick = (arenaId: string) => {
    history.push(`${path}/arena/${toDbId(arenaId)}`);
  };

  return (
    <ColumnContainer>
      <Column size="xl">
        <Card className="inset-lg">
          <Flex justifyContent="space-between">
            <Text className="stacked-md" variant="h3">
              Managers
            </Text>
          </Flex>
          <div>
            <Table>
              <TableHeader>
                <TableRow>
                  <TableCell header={true}></TableCell>
                </TableRow>
              </TableHeader>
              {/*eslint-disable-next-line @typescript-eslint/ban-ts-comment*/}
              {/* @ts-ignore */}
              <TableBody>
                {arenas?.map((arena) => {
                  return (
                    <TableRow
                      key={arena.id}
                      onClick={() => handleRowClick(arena.id)}
                      role="button"
                      tabIndex={0}
                      aria-label={arena.name}
                    >
                      <TableCell rightAligned>
                        <Flex flexDirection="row" key={arena.id}>
                          <Logo
                            className="inline-lg"
                            size="x-large"
                            name={arena.name}
                            url={arena.logoUrl}
                            aria-label={`arenaImage ${arena.id}`}
                          />
                          <Flex
                            flexDirection="row"
                            alignItems="center"
                            style={{ marginLeft: "16px" }}
                          >
                            <Text variant="strong-lg" align="right">
                              {arena.name}{" "}
                            </Text>
                          </Flex>
                        </Flex>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </div>
        </Card>
      </Column>
    </ColumnContainer>
  );
};
